let navigateFunction: ((path: string) => void) | null = null;

export const setNavigateFunction = (navigate: (path: string) => void) => {
  navigateFunction = navigate;
};

export const redirectToLogin = () => {
  if (navigateFunction) {
    navigateFunction('/login');
  } else {
    window.location.href = '/login';
  }
};

export const redirectTo = (path: string) => {
  if (navigateFunction) {
    navigateFunction(path);
  } else {
    window.location.href = path;
  }
};
